import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TermsAndConditionsRoutingModule} from './terms-and-conditions-routing.module';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbCarouselModule, NgbNavModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {GoogleMapsModule} from '@angular/google-maps';
import {TermsAndConditionsComponent} from './terms-and-conditions.component';


@NgModule({
    declarations: [TermsAndConditionsComponent],
    imports: [
        CommonModule,
        TermsAndConditionsRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule,
        NgbCarouselModule,
        NgbNavModule,
        GoogleMapsModule
    ]
})
export class TermsAndConditionsModule {
}
